import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from '~env';
import { ILoginRequestData, ILoginResponseData } from '~models/interfaces/login.interface';
import { IRefreshRequestData } from '~models/interfaces/refresh.interface';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private readonly apiUrl = environment.apiUrl;

  constructor(private httpClient: HttpClient) { }

  public login(body: ILoginRequestData): Observable<ILoginResponseData> {
    return this.httpClient.post<ILoginResponseData>(`${this.apiUrl}/api/auth/login`, body);
  }

  public logout(refreshToken: string): Observable<unknown> {
    return this.httpClient.post(`${this.apiUrl}/api/auth/logout`, { refreshToken });
  }

  public refresh(body: IRefreshRequestData): Observable<ILoginResponseData> {
    return this.httpClient.post<ILoginResponseData>(`${this.apiUrl}/api/auth/refresh`, body);
  }

  public check(): Observable<boolean> {
    return this.httpClient.get(`${this.apiUrl}/api/auth/check`).pipe(
      map(() => true),
    );
  }
}
